


























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DimssaButton from "@/components/shared/dimssa-button.vue";
import { DataManager } from "@/data-manager";

@Component({
  components: { DimssaButton }
})
export default class AnimalScanSearch extends Vue {
  @Prop() onAnimalSelected: Function;

  inputVisualTag: string = "";
  visualTags: string[] = [];
  search: any = null;
  model: any = null;
	entries: string[] = [];

	onContinue() {
		if (this.onAnimalSelected)
			this.onAnimalSelected();
		else
			console.log('onAnimalSelected is null');
	}

  filter(s: string) {
    return s.startsWith(this.search);
  }

  get items() {
    if (this.search && this.search.length >= 3) return this.visualTags;
    else return [];
  }

  async mounted() {
    this.visualTags = await this.$store.state.dataManager.getVisualTags();
    console.log("visual tags loaded");
  }

  @Watch("search")
  onSearchChanged(val: any, oldVal: any) {
    console.log("search change: " + val);
    this.entries = ["1", "2"];
  }

  @Watch("model")
  onModelChanged(val: any, oldVal: any) {
    console.log("model change: " + val);
  }
}
